<ng-container *ngIf="vm$ | async as vm">
  <uni-label>
      {{'ci.common.location' | translate}}
  </uni-label>

  <app-autocomplete-multiselect
    [currentValue]="value"
    [options]="vm.locationOptions"
    [loading]="vm.templateStatsLoading"
    [noResoultsLabel]="'ci.common.noResults' | translate"
    [placeholder]="'ci.common.location' | translate"
    [separator]="'__'"
    (valueChange)="onValueChange($event)"
  ></app-autocomplete-multiselect>

  <uni-form-field-error *ngIf="ngControl.invalid && ngControl.touched">
      {{'ci.common.fieldRequired' | translate}}
  </uni-form-field-error>
</ng-container>
